"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProgressStep = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _styles = _interopRequireDefault(require("./styles.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var renderBigCircle = function renderBigCircle(index) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "rounded-circle rounded-circle__active"
  }, index + 1);
};
var renderActiveStep = function renderActiveStep(page, index) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-step progress-step__active"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-step-icon"
  }, renderBigCircle(index), /*#__PURE__*/_react.default.createElement("div", {
    className: "progress-step-label"
  }, "".concat(page.Label))));
};
var PageComponent = /*#__PURE__*/function (_Component, _goBack) {
  (0, _inherits2.default)(PageComponent, _Component);
  var _super = _createSuper(PageComponent);
  function PageComponent(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PageComponent);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderProgressTitle", function (title) {
      if (typeof title === 'string') {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "header-title"
        }, title);
      }
      return title;
    });
    _this.state = {
      page: props.page
    };
    _this.handleNext = _this.handleNext.bind((0, _assertThisInitialized2.default)(_this));
    _this.handlePrevious = _this.handlePrevious.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleGoTo = _this.handleGoTo.bind((0, _assertThisInitialized2.default)(_this));
    _this.setPage = _this.setPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.goBack = _this.goBack.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PageComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Scroll to top on navigating forward or backward between steps
      if (prevProps.scrollToTopOnNavigating && prevState.page !== this.state.page) {
        try {
          window.scroll({
            top: 0,
            left: 0
          });
        } catch (error) {
          // Fallback for older browsers
          window.scrollTo(0, 0);
        }
      }
      if (this.props.page !== prevProps.page) {
        this.setPage();
      }
    }
  }, {
    key: "setPage",
    value: function setPage() {
      this.setState({
        page: this.props.page || 0
      });
    }
  }, {
    key: "handleNext",
    value: function handleNext() {
      this.handleGoTo(this.state.page + 1);
    }
  }, {
    key: "handlePrevious",
    value: function handlePrevious() {
      this.handleGoTo(this.state.page - 1);
    }
  }, {
    key: "handleGoTo",
    value: function handleGoTo(page) {
      if (page >= 0 && page < this.props.components.length) {
        this.setState({
          page: page
        });
      }
    }
  }, {
    key: "goBack",
    value: function goBack(_x) {
      return (_goBack = _goBack || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(index) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.props.keepCurrentData) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return this.props.keepCurrentData();
            case 3:
              this.handleGoTo(index);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }))).apply(this, arguments);
    }
  }, {
    key: "renderSmallCircle",
    value: function renderSmallCircle(index) {
      var _this2 = this;
      if (this.state.page > index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "rounded-circle rounded-circle__previous",
          role: "presentation",
          onClick: function onClick() {
            return _this2.goBack(index);
          }
        }, index + 1);
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "rounded-circle"
      }, index + 1);
    }
  }, {
    key: "renderPreviousStep",
    value: function renderPreviousStep(page, index) {
      var _this3 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-step progress-step__previous"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-step-icon"
      }, this.renderSmallCircle(index), /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-step-label",
        role: "presentation",
        onClick: function onClick() {
          return _this3.handleGoTo(index);
        }
      }, "".concat(page.Label))));
    }
  }, {
    key: "renderNextStep",
    value: function renderNextStep(page, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-step progress-step__next"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-step-icon"
      }, this.renderSmallCircle(index), /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-step-label"
      }, "".concat(page.Label))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var CurrentComponent = this.props.components[this.state.page];
      var icons = _lodash.default.map(this.props.components, function (page, index) {
        if (index > _this4.state.page) {
          return _this4.renderNextStep(page, index);
        }
        if (index < _this4.state.page) {
          return _this4.renderPreviousStep(page, index);
        }
        return renderActiveStep(page, index);
      });
      var totalSteps = this.props.components.length - 1;
      var percentPerStep = 100 / totalSteps;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default['search-component']
      }, this.props.backButton ? this.props.backButton() : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-step-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-title"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "title-width"
      }, " ", this.renderProgressTitle(this.props.title), " ")), /*#__PURE__*/_react.default.createElement("div", {
        className: "list-step"
      }, icons, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-path"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "progress-path progress-path__passed",
        style: {
          maxWidth: "".concat(percentPerStep * this.state.page, "%")
        }
      }))))), /*#__PURE__*/_react.default.createElement(CurrentComponent, (0, _extends2.default)({}, this.props, {
        onNext: this.handleNext,
        onPrevious: this.handlePrevious,
        onGoTo: this.handleGoTo,
        page: this.state.page,
        startPage: this.props.page
      })));
    }
  }]);
  return PageComponent;
}(_react.Component);
PageComponent.propTypes = {
  page: _propTypes.default.number,
  components: _propTypes.default.arrayOf(_propTypes.default.element).isRequired,
  backButton: _propTypes.default.func,
  scrollToTopOnNavigating: _propTypes.default.bool,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  keepCurrentData: _propTypes.default.func
};
PageComponent.defaultProps = {
  page: 0,
  backButton: null,
  scrollToTopOnNavigating: true,
  title: '',
  keepCurrentData: null
};
var _default = PageComponent;
exports.default = _default;
var ProgressStep = PageComponent;
exports.ProgressStep = ProgressStep;